import { takeLatest, call, put, select } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { getCommonApiParams } from "../../../../utils/redux-helpers.js";
import { stringify } from "../../../../utils/stringify.js";
import { api } from "../api.js";

export const SET_LOADING = "saga/attritionAndCancelReasons/SET_LOADING";
export const SET_UPDATES_LOADING = "saga/attritionAndCancelReasons/SET_UPDATES_LOADING";
export const SET_FILTERS_DIRTY = "saga/attritionAndCancelReasons/SET_FILTERS_DIRTY";
export const SET_MODULE_VIEW = "saga/attritionAndCancelReasons/SET_MODULE_VIEW";

export const FETCH_CURRENT_USER = "saga/attritionAndCancelReasons/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS =
  "saga/attritionAndCancelReasons/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_FILTERS_SUCCESS = "saga/attritionAndCancelReasons/FETCH_FILTERS_SUCCESS";
export const FETCH_DATA_SUCCESS = "saga/attritionAndCancelReasons/FETCH_DATA_SUCCESS";

export const UPDATE_DATA = "saga/attritionAndCancelReasons/UPDATE_DATA";
export const RESET_DATA = "saga/attritionAndCancelReasons/RESET_DATA";

export const UPDATE_MODULE_VIEW = "saga/attritionAndCancelReasons/UPDATE_MODULE_VIEW";
export const UPDATE_DATE = "saga/attritionAndCancelReasons/UPDATE_DATE";
export const UPDATE_FILTER = "saga/attritionAndCancelReasons/UPDATE_FILTER";
export const RESET_FILTER = "saga/attritionAndCancelReasons/RESET_FILTER";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateDate: createAction(UPDATE_DATE),
  updateFilter: createAction(UPDATE_FILTER),
  updateModuleView: createAction(UPDATE_MODULE_VIEW),
  updateData: createAction(UPDATE_DATA),
  resetData: createAction(RESET_DATA)
};

export default function* watchAttritionAndCancelReasons() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(UPDATE_DATA, updateData);
  yield takeLatest(RESET_DATA, resetData);
  yield takeLatest(UPDATE_MODULE_VIEW, updateView);
}

function* getCurrentUserData(data) {
  try {
    yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: data.payload });

    yield fetchFilters();
    yield fetchData();

    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* fetchFilters() {
  let params = yield getCommonApiParams("commonReducer", "commonProps");

  let { data } = yield call(api.getFilters, { params });

  try {
    yield put({
      type: FETCH_FILTERS_SUCCESS,
      payload: data
    });
  } catch (error) {
    console.error(error);
  }
}

function* updateView({ payload }) {
  yield put({ type: SET_MODULE_VIEW, payload });
  yield put({ type: RESET_FILTER });

  yield put({ type: SET_LOADING, payload: true });

  try {
    yield fetchData();
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* getApiParams() {
  let { membership_types, date, moduleView } = yield select(
    (state) => state.attritionAndCancelReasons.selectedFilters
  );

  return {
    membership_type_ids: stringify(membership_types),
    date,
    attrition_rate_logic: moduleView.id
  };
}

function* fetchData() {
  let commonParams = yield getCommonApiParams("commonReducer", "commonProps");
  let params = yield getApiParams("attritionAndCancelReasons");

  if (!params.membership_type_ids) return;

  let { data } = yield call(api.getData, { ...commonParams, ...params });

  try {
    yield put({
      type: FETCH_DATA_SUCCESS,
      payload: { ...data }
    });
  } catch (error) {
    console.error(error);
  }
}

function* updateData() {
  yield put({ type: SET_FILTERS_DIRTY, payload: false });
  yield put({ type: SET_UPDATES_LOADING, payload: true });

  try {
    yield fetchData();
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* resetData() {
  yield put({ type: SET_UPDATES_LOADING, payload: true });

  yield put({ type: RESET_FILTER });

  try {
    yield fetchData();
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}
